import { Component } from 'react';
import ReactDOM from 'react-dom';

/**
 * The base class for all the Social Networks used in Social Media Feed widget
 */
export default class ShareBarBase extends Component {
  componentDidMount() {
    // This is done to make the widget appear on Preview Mode since, this is inside an Iframe
    try {
      const node = ReactDOM.findDOMNode(this);
      this.window = node && node.ownerDocument.defaultView;
    } catch (e) {
      this.window = window;
    }
  }

  addQueryParamsToURL = (url, additionalURLParams) => {
    if (!additionalURLParams.length) {
      return url;
    }
    const paramString = additionalURLParams.filter(e => e).join('&');
    return (url.indexOf('?') === -1) ? `${url}?${paramString}` : `${url}&${paramString}`;
  }
}
